<template>
  <ConclusionStep
    data-testid="conclusion"
    class="conclusion"
    status="positive"
    title="Investimento solicitado"
    :description="description"
    @close="goToPortfolio"
  >
    <ListDisplay
      v-for="(detail, index) in details"
      :key="index"
      :has-divider="index !== details.length - 1"
      :title="detail.label"
      :value="detail.value"
    />
    <Message class="conclusion__message">
      <template #description>
        Quando o mercado estiver fechado, sua movimentação será agendada.
        Mantenha o valor disponível na Conta Digital no próximo dia útil para
        garantir a execução.
      </template>
    </Message>
    <template #button-primary>
      <ButtonPrimary label="Ver Carteira" size="large" @click="goToPortfolio" />
    </template>
  </ConclusionStep>
</template>

<script setup lang="ts">
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ListDisplay,
  ButtonPrimary,
  MessageFoundation as Message
} from '@warrenbrasil/nebraska-web';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const description = computed(() => {
  return `Aplicação prevista para ${investmentDetails.value.expectedInvestmentDate}`;
});

const details = computed(() => {
  return [
    {
      label: 'Valor do investimento',
      value: `R$ ${amountFormatted.value}`
    },
    {
      label: 'Origem',
      value: 'Conta digital'
    },
    {
      label: 'Destino',
      value: investmentDetails.value.portfolioName
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value },
    query: { tab: 'orders' }
  });
}
</script>

<style lang="less" scoped>
.conclusion {
  :deep(.flow-conclusion__details) {
    align-items: initial;
  }
  .list-display {
    margin-top: @size-spacing-x350;

    &:first-of-type {
      margin-top: @size-spacing-x600;
    }

    &:last-of-type {
      margin-bottom: @size-spacing-x500;
    }
  }

  &__message {
    margin-top: @size-spacing-x400;
  }
}
</style>
